import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleLeft, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import Validation from "../../common/FormValidation";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import { SelectImageData } from "../../../utils/common";
import { useNavigate } from "react-router";
import Header from "../../Header/Header";
import VarientSection from "./Varient";
import { useParams } from "react-router-dom";

library.add(fas);

const EditOffCanvance = (props) => {
  const navigate = useNavigate();

  // const id = props.show;
  const { id } = useParams();
  const { postData, getData, Select2Data, IMG_URL } = useContext(Context);
  const [countries, setCountries] = useState([]);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(
      `/admin/purchase-order/purchase-product/${id}`
    );
    reset(response?.data);
  };

  const GetAllCategory = async () => {
    const response = await getData("/common/masters/all-p-category");

    if (response?.success) {
      setCountries(await Select2Data(response?.data, "p_category_id"));
    }
  };

  useEffect(() => {
    GetAllCategory();
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
    watch,
  } = useForm();

  const [product, setProduct] = useState([]);

  const GetAllProduct = async () => {
    const response = await getData("/common/masters/product");

    if (response?.success) {
      setProduct(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);
  const watchQuantitys = watch("quantitys");

  const totalQuantity =
    watchQuantitys?.reduce((sum, item) => {
      const qty = parseFloat(item?.receive_quantity);
      return sum + (isNaN(qty) ? 0 : qty);
    }, 0) || 0;

  const totalPrice =
    watchQuantitys?.reduce((sum, item) => {
      const qty = parseFloat(item?.receive_quantity);
      const price = parseFloat(item?.price);
      const total = (isNaN(qty) ? 0 : qty) * (isNaN(price) ? 0 : price);
      return sum + total;
    }, 0) || 0;

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("id", data?.id);
      DataToSend.append("total_quantity", totalQuantity);
      DataToSend.append("total_price", totalPrice);
      DataToSend.append("batch_no", data?.batch_no);
      // DataToSend.append("expiry_date", data?.expiry_date);
      DataToSend.append("supplier_id", data?.supplier_id?.value);

      const quantity = [];

      data.quantitys.forEach((val, index) => {
        const qty = parseFloat(val?.receive_quantity) || 0;
        const price = parseFloat(val?.price) || 0;
        const total = (qty * price).toFixed(2);

        const quantityItem = {
          id: val?.id,
          product_id: val?.product_id?.value,
          quantity: val?.receive_quantity || 0,
          expiry_date: val?.expiry_date,
          price: val?.price || 0,
          total_price: total,
          varients: [],
        };

        val.varients?.forEach((variant) => {
          quantityItem.varients.push({
            product_id: val?.product_id?.value,
            variant_id: variant?.varient_id,
            general_stock: variant?.general_stock || 0,
            selling_price: variant?.selling_price || 0,
            subscription_stock: variant?.subscription_stock || 0,
          });
        });

        quantity.push(quantityItem);
      });

      DataToSend.append("quantitys", JSON.stringify(quantity));
      const response = await putData(
        `/admin/purchase-order/purchase-product/receiving/${id}`,
        DataToSend
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        navigate("/purchase-product/purchase-product");
        // props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "quantitys",
  });

  const [supplier, setSupplier] = useState([]);
  const GetAllSupplier = async () => {
    const response = await getData("/common/masters/all-supplier");
    if (response?.success) {
      setSupplier(await Select2Data(response?.data, "supplier_id"));
    }
  };
  useEffect(() => {
    GetAllSupplier();
  }, []);
  return (
    <>
      <Header title={"Product Purchase Compare"} link={"#"} />
      <section className="Create">
        <div className="back_btn_holder">
          <div onClick={() => navigate(`/purchase-product/purchase-product`)}>
            <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
            Back
          </div>
        </div>

        <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
          <Row>
            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="row justify-content-center mb-2">
                  <Form.Label>Supplier</Form.Label>

                  <Controller
                    name="supplier_id" // name of the field
                    {...register("supplier_id", {
                      required: "Select Supplier",
                    })}
                    control={control}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.supplier_id
                              ? "red"
                              : baseStyles,
                          }),
                        }}
                        {...field}
                        options={supplier}
                        // onChange={(selectedOption) => {
                        //   field.onChange(selectedOption.value); // Update Controller's value
                        //   GetAllStates(selectedOption.value);
                        //   setValue("country_id", selectedOption);
                        //   setValue("state_id", null);
                        // }}
                      />
                    )}
                  />

                  {errors.supplier_id && (
                    <span className="text-danger">
                      {errors.supplier_id.message}
                    </span>
                  )}
                </Row>
              </div>
            </Col>
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6> Receiving Quanitity</h6>
              </div>

              <div className="package-details-section">
                {fields.map((variant, index) => (
                  <div key={variant.id} className="main-form-section mt-3">
                    <Row>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Product</Form.Label>
                            <Form.Group>
                              <Controller
                                name={`quantitys.${index}.product_id`} // name of the field
                                {...register(`quantitys.${index}.product_id`, {
                                  required: "Select Product",
                                })}
                                control={control}
                                render={({ field }) => (
                                  <Select
                                   isDisabled={true}
                                    styles={{
                                      control: (baseStyles) => ({
                                        ...baseStyles,
                                        borderColor: errors?.add_on?.[index]
                                          ?.product_id
                                          ? "red"
                                          : baseStyles,
                                      }),
                                    }}
                                    {...field}
                                    options={product}
                                  />
                                )}
                              />
                              {errors?.quantitys?.[index]?.product_id && (
                                <span className="text-danger">
                                  {errors.quantitys[index].product_id.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Purchase Quantity</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`quantitys.${index}.quantity`} // Register color for the variant
                                placeholder="Quanitity"
                                readOnly
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.quantitys?.[index]?.quantity,
                                })}
                                {...register(`quantitys.${index}.quantity`, {
                                  required: "Quanitity is required",
                                })}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight"
                                  ) {
                                    return; // Allow the action to continue
                                  }

                                  // Allow digits and decimal point
                                  if (!/[\d.]/.test(e.key)) {
                                    e.preventDefault(); // Block the invalid key
                                  }

                                  if (
                                    e.key === "." &&
                                    e.target.value.includes(".")
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                              {errors?.quantitys?.[index]?.quantity && (
                                <span className="text-danger">
                                  {errors.quantitys[index].quantity.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Recevie Quantity</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`quantitys.${index}.receive_quantity`} // Register color for the variant
                                placeholder="Quanitity"
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.quantitys?.[index]
                                      ?.receive_quantity,
                                })}
                                {...register(
                                  `quantitys.${index}.receive_quantity`,
                                  {
                                    required: "Quanitity is required",
                                  }
                                )}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight"
                                  ) {
                                    return; // Allow the action to continue
                                  }

                                  // Allow digits and decimal point
                                  if (!/[\d.]/.test(e.key)) {
                                    e.preventDefault(); // Block the invalid key
                                  }

                                  if (
                                    e.key === "." &&
                                    e.target.value.includes(".")
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                              {errors?.quantitys?.[index]?.receive_quantity && (
                                <span className="text-danger">
                                  {
                                    errors.quantitys[index].receive_quantity
                                      .message
                                  }
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Price</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`quantitys.${index}.price`} // Register color for the variant
                                placeholder="Quanitity"
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.quantitys?.[index]?.price,
                                })}
                                {...register(`quantitys.${index}.price`, {
                                  required: "price is required",
                                })}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight"
                                  ) {
                                    return; // Allow the action to continue
                                  }

                                  // Allow digits and decimal point
                                  if (!/[\d.]/.test(e.key)) {
                                    e.preventDefault(); // Block the invalid key
                                  }

                                  if (
                                    e.key === "." &&
                                    e.target.value.includes(".")
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                              {errors?.quantitys?.[index]?.price && (
                                <span className="text-danger">
                                  {errors.quantitys[index].price.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Total</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`quantitys.${index}.total_price`}
                                value={(() => {
                                  const receiveQty =
                                    parseFloat(
                                      watch(
                                        `quantitys.${index}.receive_quantity`
                                      )
                                    ) || 0;
                                  const price =
                                    parseFloat(
                                      watch(`quantitys.${index}.price`)
                                    ) || 0;
                                  return (receiveQty * price).toFixed(2);
                                })()}
                                readOnly
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.quantitys?.[index]?.total_price,
                                })}
                              />
                              {errors?.quantitys?.[index]?.total_price && (
                                <span className="text-danger">
                                  {errors.quantitys[index].total_price.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Expiry Date</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="date"
                                name={`quantitys.${index}.expiry_date`}
                                placeholder="Quantity"
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.quantitys?.[index]?.expiry_date,
                                })}
                                min={new Date().toISOString().split("T")[0]} // disable past dates in picker
                                {...register(`quantitys.${index}.expiry_date`, {
                                  required: "Expiry Date is required",
                                  validate: (value) => {
                                    const selectedDate = new Date(value);
                                    const today = new Date();
                                    today.setHours(0, 0, 0, 0);
                                    return (
                                      selectedDate > today ||
                                      "Expiry Date must be in the future"
                                    );
                                  },
                                })}
                                onBlur={(e) => {
                                  const value = e.target.value;
                                  if (value) {
                                    const selectedDate = new Date(value);
                                    const today = new Date();
                                    today.setHours(0, 0, 0, 0);
                                    if (selectedDate <= today) {
                                      e.target.blur(); // remove focus from the input if past date is entered
                                    }
                                  }
                                }}
                              />

                              {errors?.quantitys?.[index]?.expiry_date && (
                                <span className="text-danger">
                                  {errors.quantitys[index].expiry_date.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      {/* <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Expiry Date</Form.Label>
                            <Form.Group>
                              <Controller
                                name="expiry_date"
                                control={control}
                                rules={{
                                  required: "Select Date",
                                  validate: (value) =>
                                    new Date(value) > new Date() ||
                                    "Expiry date must be in the future",
                                }}
                                render={({ field }) => (
                                  <input
                                    type="date"
                                    min={new Date().toISOString().split("T")[0]} // disables past dates
                                    className={`form-control ${
                                      errors.expiry_date ? "is-invalid" : ""
                                    }`}
                                    {...field}
                                  />
                                )}
                              />
                              {errors.expiry_date && (
                                <div className="invalid-feedback">
                                  {errors.expiry_date.message}
                                </div>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col> */}

                      <VarientSection
                        product_id={getValues(`quantitys.${index}.product_id`)}
                        weekIndex={index}
                        control={control}
                        register={register}
                        getValues={getValues}
                        errors={errors}
                        setValue={setValue}
                      />
                    </Row>
                    {/* {fields.length > 1 && (
                        <button
                          className="mt-3 add-varient"
                          type="button"
                          onClick={() => remove(index)} // Remove the variant
                        >
                          Remove Quanitity
                        </button>
                      )} */}
                    <hr />
                  </div>
                ))}
                <div>Total Quantity:{totalQuantity}</div>
                <div>Total Price:{totalPrice}</div>
              </div>
              <hr />
              {/* <div className="text-center">
                  <button
                    type="button"
                    className="add-varient"
                    onClick={() => append({})}
                  >
                    + Add Quanitity
                  </button>
                </div> */}
            </div>

            <Row className="mt-5 pb-3">
              <div className="d-flex justify-content-center">
                <Link to={"/purchase-product/purchase-product"}>
                  <CancelButton
                    name={"cancel"}
                    handleClose={props.handleClose}
                  />
                </Link>

                <SaveButton
                  name={"save"}
                  handleSubmit={handleSubmit(onSubmit)}
                />
              </div>
            </Row>
          </Row>
        </Form>
      </section>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
